<template>
    <div>

        <div :id="id"
             :style="isTransitionDisabled ? 'transition: none!important;' : ''"
             :class="'uk-modal' + (isExtended ? ' uk-modal-container' : '') + (isFull ? ' uk-modal-full' : '')"
             :uk-modal="isStrict ? 'esc-close: false; bg-close:false;' : ''">
            <div :id="id+'-body'"
                 :style="isTransitionDisabled ?  'transition: none!important;' : ''"
                :class="(isWithoutDialog? '': 'uk-modal-dialog') + (isDark? '  dark': '') + (isRound? ' round': '') + (isWithoutBody? '': ' uk-modal-body' ) + (isCentered? ' uk-margin-auto-vertical' :'') + (isMedium ? ' medium' : '')">

                <span v-if="!isWithoutClose && !isStrict">
                    <button v-if="isCloseOutside" class="uk-modal-close-outside" type="button" uk-close/>
                    <button v-else class="uk-modal-close-default" type="button" uk-close/>
                </span>

                <ModalTitle :id="idTitle" v-if="title" :title="title" class="uk-text-center" is-dark/>

                <slot/>

            </div>
        </div>

    </div>
</template>

<script>

import ModalTitle from "@/components/generic/ModalTitle";

export default {
    name: 'Modal',
    components: {ModalTitle},
    props: {
        id: String,
        idTitle: String,
        isExtended: Boolean,
        isMedium: Boolean,
        title: String,
        isCentered: Boolean,
        isWithoutBody: Boolean,
        isCloseOutside: Boolean,
        isFull: Boolean,
        isWithoutClose: Boolean,
        isWithoutDialog: Boolean,
        isDark: Boolean,
        isStrict: Boolean,
        isTransitionDisabled: Boolean,
        isRound: Boolean,
    },
}

</script>

<style lang="scss" scoped>

.round {
    border-radius: 5px!important;
}

.uk-modal {
    color: $site-background-hover;
}

.uk-modal-dialog {
    border-radius: $border-radius;

    &.dark {
        background-color: #000;
    }

    &.medium {
        width: 800px !important;
    }
}

</style>
